export default "__VITE_ASSET__1f314576__"